export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-amazon-dark border-t border-amazon-dark-lighter">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-amazon-orange rounded-lg flex items-center justify-center">
              <span className="text-amazon-dark font-bold text-sm">E</span>
            </div>
            <span className="text-gray-400 text-sm">The Essentials List</span>
          </div>

          <p className="text-gray-500 text-sm text-center">
            &copy; {currentYear} The Essentials List. All rights reserved.
          </p>

          <div className="flex items-center space-x-4">
            <a
              href="#converter"
              className="text-gray-400 hover:text-amazon-orange text-sm transition-colors"
            >
              Link Generator
            </a>
            <span className="text-gray-600">|</span>
            <a
              href="#categories"
              className="text-gray-400 hover:text-amazon-orange text-sm transition-colors"
            >
              Categories
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
